import { VFC } from 'react'
import { RequestBoxCompany } from 'src/models/RequestBox'
import {
  accentColor,
  _menuicon,
  _messagebg,
  _messagesbg,
} from 'src/styles/colors'
import { fontWeightBold, fontWeightMedium } from 'src/styles/font'
import { flexCenter } from 'src/styles/mixins'
import styled from 'styled-components'

const RequestBoxContentComponent: VFC<{
  requestBox: RequestBoxCompany
  className?: string
}> = ({ requestBox, className }) => {
  return (
    <ContentDiv className={className}>
      <p>つながり申請理由</p>
      <TextDiv>{requestBox.requestReasonText}</TextDiv>
    </ContentDiv>
  )
}

export const RequestBoxContent = styled(RequestBoxContentComponent)``

const ContentDiv = styled.div`
  font-size: 14px;
  font-weight: ${fontWeightMedium};
  padding: 16px;
  background: ${_messagebg};
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  p {
    color: ${_menuicon};
  }
`

const TextDiv = styled.div`
  ${flexCenter};
  background: ${_messagesbg};
  color: ${accentColor};
  font-size: 16px;
  font-weight: ${fontWeightBold};
  padding: 24px;
  border-radius: 10px;
  letter-spacing: 1.15px;
`
